/*
 * MIST Originals basket nudge (snippets/mist-cart-nudge.liquid).
 * "Switch to …": remove the line, add the suggested variant at the same quantity, then repaint the drawer (or reload /cart).
 * "Not sure? Chat to us": opens the support chat when it's loaded, else follows the contact-page link.
 */
(() => {
  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => {
      if (!r.ok) throw new Error(`${url} ${r.status}`);
      return r.json();
    });

  document.addEventListener('click', async (event) => {
    const chat = event.target.closest?.('[data-mist-chat]');
    if (chat && window.$chatwoot?.toggle) {
      event.preventDefault();
      window.$chatwoot.toggle('open');
      return;
    }

    const swap = event.target.closest?.('[data-mist-swap]');
    if (!swap || swap.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    swap.setAttribute('aria-busy', 'true');
    const quantity = parseInt(swap.dataset.quantity, 10) || 1;
    try {
      await post('/cart/change.js', { id: swap.dataset.lineKey, quantity: 0 });
      await post('/cart/add.js', { items: [{ id: Number(swap.dataset.variantId), quantity }] });
    } catch (error) {
      console.error(error);
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && swap.closest('cart-drawer') && typeof drawer.refresh === 'function') {
      await drawer.refresh();
    } else {
      window.location.reload();
    }
  });
})();
